(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/validated/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/validated/page.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useState,
  useEffect
} = React;
const Button = svs.ui.ReactButton;
const {
  PageWrapper
} = svs.ticketsValidate.components;
const Envelope = svs.tur.Envelope;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const templateBranding = svs.tickets.data.templateConfig.branding;
const {
  GamingAccountInfo
} = svs.ticketsValidate.components;
const WinActions = _ref => {
  let {
    winAmount,
    isHighWin,
    trackType,
    paused,
    ticketPrice,
    resolvedBranding
  } = _ref;
  const {
    pathname
  } = ReactRouterDOM.useLocation();
  const isPlural = Math.floor(winAmount / ticketPrice) > 1;
  const envelopeTitle = isPlural ? 'Vill du lösa in din vinst mot nya lotter?' : 'Vill du lösa in din vinst mot en ny lott?';
  const confirmRedeemTicket = () => {
    if (winAmount > 150) {
      const ticketValidateHome = svs.core.urlMapping.get('ticketValidateHome');
      svs.utils.url.navigate("".concat(ticketValidateHome === null || ticketValidateHome === void 0 ? void 0 : ticketValidateHome.replace(':branding', resolvedBranding), "/hogvinst"));
    } else {
      svs.utils.url.navigate("".concat(svs.core.data.baseUrl).concat(pathname, "/los-in"));
    }
  };
  const confirmGamingAccount = () => {
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateKeepWinChosen(trackType);
    svs.utils.url.navigate("".concat(svs.core.urlMapping.get('transactionsAccountHistory')));
  };
  if (isHighWin) {
    return React.createElement("div", {
      "data-testid": "tickets-validate-high-win"
    });
  }
  return React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-bottom-1"
  }, React.createElement("h4", {
    className: "h4 margin-top-1 validate-font-weight"
  }, envelopeTitle), React.createElement("div", {
    className: "u-flex u-flex-column"
  }, !paused && React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    focus: true,
    onClick: confirmRedeemTicket,
    type: "button"
  }, "Ja, det l\xE5ter bra!"), React.createElement(Button, {
    block: true,
    className: "confirmGamingAccountButton u-text-decoration-underline",
    onClick: confirmGamingAccount,
    transparent: true,
    type: "button"
  }, "G\xE5 till ditt spelkonto")));
};
setGlobal('svs.ticketsValidate.pages.Validated', _ref2 => {
  let {
    match
  } = _ref2;
  const {
    pathname
  } = ReactRouterDOM.useLocation();
  const [bubbleWinOptions, setBubbleWinOptions] = useState();
  const ticketInfo = svs.ticketsValidate.data.retailTicketInfo;
  const productType = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type;
  const ticketId = match.params.ticketId;
  const ticketBranding = svs.ticketsValidate.utils.getBrandByTicketId(ticketId) || templateBranding;
  const resolvedBranding = (ticketBranding || '').includes('triss') ? 'triss' : 'skrapspel';
  const shortName = svs.ticketsValidate.utils.getShortNameByTicketId(ticketId);
  const {
    state
  } = svs.ticketsValidate.components.context.useValidateContext();
  const {
    fetchingDepositLimits,
    hasDepositLimits = false
  } = svs.ticketsValidate.pages.validated.useDepositLimits();
  const isPausedOrHasDepositLimits = svs.tur.data.pauseCheck.isPaused || hasDepositLimits;
  const image = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.image;
  const result = state.result;
  const winAmount = (bubbleWinOptions === null || bubbleWinOptions === void 0 ? void 0 : bubbleWinOptions.amount) || 0;
  const brand = resolvedBranding;
  const trackType = shortName || productType;
  useEffect(() => {
    const normalizedWin = svs.ticketUtility.utils.normalizeWinRetail(result);
    setBubbleWinOptions(_objectSpread({
      demo: false,
      product: ticketInfo.type,
      disableGrassroot: true
    }, normalizedWin));
    if (normalizedWin.winFlag) {
      setTimeout(() => {
        svs.tur.confettiCannon();
      }, 750);
    }
  }, [result, ticketInfo]);
  const onBuyDigitalTickets = () => {
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateBuyNewTicketsOnlineChosen(trackType);
    if (winAmount < ticketInfo.price || winAmount > 150) {
      const home = resolvedBranding === 'triss' ? svs.core.urlMapping.get('trissHome') : svs.core.urlMapping.get('skrapspelHome');
      svs.utils.url.navigate("".concat(home, "?rl=").concat(encodeURIComponent(JSON.stringify({
        winAmount
      }))));
    } else {
      const returnUrl = encodeURIComponent("".concat(svs.core.data.baseUrl).concat(pathname));
      svs.utils.url.navigate("/".concat(brand, "/kop-flera/kop/").concat(productType, "?vinst=").concat(winAmount, "&returnUrl=").concat(returnUrl));
    }
  };
  const onValidateNewTicket = e => {
    e === null || e === void 0 || e.preventDefault();
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateCorrectNewTicket(shortName);
    const ticketsValidateManualUrl = svs.core.urlMapping.get('ticketsValidateManual');
    svs.utils.url.navigate(ticketsValidateManualUrl);
  };
  if (fetchingDepositLimits) {
    return null;
  }
  return React.createElement(PageWrapper, {
    className: "validated-page padding-top-3"
  }, React.createElement(React.Fragment, null, bubbleWinOptions && React.createElement("div", {
    className: "bubble-win-message-wrapper"
  }, React.createElement(BubbleWinMessage, {
    options: bubbleWinOptions
  })), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center padding-top-1"
  }, React.createElement(Envelope, {
    branding: ticketBranding,
    image: image,
    repeatImage: 1
  }, bubbleWinOptions !== null && bubbleWinOptions !== void 0 && bubbleWinOptions.amount ? React.createElement(WinActions, {
    isHighWin: bubbleWinOptions.extraicon,
    paused: isPausedOrHasDepositLimits,
    resolvedBranding: resolvedBranding,
    ticketPrice: ticketInfo.price,
    trackType: trackType,
    winAmount: bubbleWinOptions.amount
  }) : React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-top-2"
  }, !isPausedOrHasDepositLimits && React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    focus: true,
    onClick: onBuyDigitalTickets,
    type: "button"
  }, "K\xF6p ny digital lott"), React.createElement(Button, {
    block: true,
    className: isPausedOrHasDepositLimits ? 'margin-top-1' : '',
    focus: true,
    onClick: onValidateNewTicket,
    transparent: true,
    type: "button"
  }, "R\xE4tta ny lott")))), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center margin-top-2"
  }, React.createElement("div", {
    className: "tickets-validate-envelope-width"
  }, result.winAmount > 0 && React.createElement(GamingAccountInfo, null)))));
});

 })(window);